/* eslint-disable */
import React, { useEffect, useState, useRef, useMemo } from "react";
import { Link, useParams, useHistory } from "react-router-dom";
import Select from "react-select";

// Import JoditEditor here.
import JoditEditor from "jodit-react";

//import images
import { assetImages } from "constants";

//import options
import publishOptions from "data/Prod/PublishOptions.json";

//import download file
import fileDownloadHandler from "helper/DownloadFile";

/*------ import url and method ------*/
import * as url from "helper/UrlHelper";
import {
  postData,
  getData,
  putData,
  uploadSingleFile,
  uploadMultipleFile,
} from "utils/Gateway";

import BlogSuccessMessageModal from "../Modal/BlogSuccessMessageModal";
import BreadCrumb from "components/Common/BreadCrumb/BreadCrumb";
import downloadFileHandler from "helper/DownloadFile";
import { getAllCategories } from "helper/CategoryHelper/CategoryHelper";
import { useTranslation } from "react-i18next";
import { getCustomStyles, reactSelectStyle } from "Config/Config";
import AccessDeniedView from "components/Common/AccessDeniedView/AccessDeniedView";
import FileUploadField from "components/Common/FileUploadField/FileUploadField";

const AddUpdateBlogBody = () => {
  const editor = useRef(null);
  const token = localStorage.getItem("token");
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));
  const ecosystemSlug = localStorage.getItem("ecosystemslug");
  const moduleAccess = localStorage.getItem("moduleaccess");
  const { t } = useTranslation(); //for translation
  const todayValue = new Date().toISOString().split("T")[0];

  // Extract 'type' parameter from URL query string
  const queryParams = new URLSearchParams(window.location.search);
  const companyIdParam = queryParams.get("companyid");

  const params = useParams();
  const history = useHistory();
  const loadingCircle = [1, 2, 3, 4, 5, 6];

  const coverImageFileInputRef = useRef(null);
  const uploadFileInputRef = useRef(null);

  const [categoryList, setCategoryList] = useState([]);

  const [companyInput, setCompanyInput] = useState("");
  const [companyList, setCompanyList] = useState([]);

  const [blogName, setBlogName] = useState("");
  const [isImageUploading, setIsImageUploading] = useState(false);
  const [coverImageUrl, setCoverImageUrl] = useState("");
  const [coverImageId, setCoverImageId] = useState(null);
  const [blogSummary, setBlogSummary] = useState("");
  const [blogDetails, setBlogDetails] = useState("");
  const [categoryValue, setCategoryValue] = useState(null);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [companyValue, setcompanyValue] = useState(null);
  const [selectedCompanyId, setselectedCompanyId] = useState(null);
  const [facebookUrl, setFacebookUrl] = useState("");
  const [pinterestUrl, setPinterestUrl] = useState("");
  const [contactEmail, setContactEmail] = useState("");
  const [linkUrl, setLinkUrl] = useState("");
  const [isFileUploading, setIsFileUploading] = useState(false);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [uploadedFileIds, setUploadedFileIds] = useState([]);
  const [publishValue, setPublishValue] = useState(null);
  const [publishStatus, setPublishStatus] = useState(null);
  const [isSaving, setIsSaving] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [errors, setErrors] = useState({});

  // const editorCustomConfig = joditEditorConfig();
  const editorCustomConfig = {
    readonly: false,
    placeholder: "",
    height: 300,
    uploader: {
      insertImageAsBase64URI: false,
    },
    events: {
      afterPaste: async (event) => {
        // take the saved clipboard data
        const clipboardData = event.clipboardData || window.clipboardData;
        const items = clipboardData.items;

        for (let i = 0; i < items.length; i++) {
          if (items[i].type.indexOf("image") !== -1) {
            const file = items[i].getAsFile();

            // Rename the file using a timestamp
            const timestamp = Date.now();
            const fileExtension = file.type.split("/")[1]; // Get the file extension (e.g., png, jpeg)
            const newFileName = `image-${timestamp}.${fileExtension}`;

            const renamedFile = new File([file], newFileName, {
              type: file.type,
            });

            try {
              // upload the file data in server
              const requestUrl =
                url.API_BASE_URL +
                url.API_SINGLE_FILE_UPLOAD +
                `?token=${token}`;

              const response = await uploadSingleFile(requestUrl, renamedFile);

              if (response.status) {
                const imageUrl = url.SERVER_URL + response.data.path;
                // console.log("imageUrl", imageUrl);

                // Replace blob URL with the server URL
                const editorInstance = editor.current;

                if (editorInstance) {
                  const content = editorInstance.value;
                  const regex = /<img[^>]+src="data:image\/[^">]+"/g;
                  const newContent = content.replace(regex, (match) => {
                    const base64DataMatch = match.match(/src="([^"]+)"/);
                    if (
                      base64DataMatch &&
                      base64DataMatch[1].startsWith("data:image/")
                    ) {
                      return match.replace(base64DataMatch[1], imageUrl);
                    }
                    return match;
                  });

                  // add in editor content
                  editorInstance.value = newContent;

                  // add in state content
                  setBlogDetails(newContent);
                }
              }
            } catch (error) {
              console.error("Image upload failed:", error);
            }
          }
        }
      },
    },
    defaultActionOnPaste: "insert_as_html",
    defaultLineHeight: 1.5,
    enter: "div",
    statusbar: false,
    sizeLG: 900,
    sizeMD: 700,
    sizeSM: 400,
    toolbarAdaptive: false,
    disablePlugins: [
      "image",
      "video",
      "about",
      "classSpan",
      "file",
      "speechRecognize",
      "copyformat",
      "spellcheck",
      "add-new-line",
    ],
  };

  const editorConfig = useMemo(() => editorCustomConfig, []);

  const validateForm = () => {
    const newErrors = {};

    if (!blogName.trim()) {
      newErrors.blogName = t("Title is required") + " !";
    }
    if (!coverImageId) {
      newErrors.coverImage = t("Cover image is required") + " !";
    }
    if (!blogSummary.trim()) {
      newErrors.blogSummary = t("Summary is required") + " !";
    }
    if (!blogDetails.trim()) {
      newErrors.blogDetails = t("Details is required") + " !";
    }
    if (!categoryValue || categoryValue.length === 0) {
      newErrors.category = t("Category is required") + " !";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  //function for get all contacts
  const getAllCompanyList = async () => {
    try {
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_ALL_COMPANY_LIST +
        `?token=${token}&filtername=${companyInput}`;

      const response = await getData(requestUrl);

      console.log("response in company------>", response);

      if (response.status) {
        setCompanyList(response.data);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  //function for company details for query params
  const getCompanyDetails = async () => {
    try {
      let requestUrl = `${url.API_BASE_URL}${url.API_GET_COMPANY_DETAILS}/${companyIdParam}?token=${token}&modulefrom=backend`;
      const response = await getData(requestUrl);

      if (response.status) {
        const companyObj = {
          label: response.data.name,
          value: response.data._id,
        };

        companySelectionHandler(companyObj);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  //function for get all category
  const fetchAllCategories = async () => {
    try {
      const parentSlug = "blogpost";
      const response = await getAllCategories(ecosystemSlug, parentSlug);

      setCategoryList(response);
    } catch (error) {
      console.log(error.message);
    }
  };

  //function for open image imput
  const openCoverImageFileInput = () => {
    coverImageFileInputRef.current.click();
  };

  //function for image upload
  const coverImageUploadHandler = async (file) => {
    setErrorMessage("");
    setErrors((prev) => ({ ...prev, coverImage: "" }));

    setIsImageUploading(true);
    try {
      const requestUrl =
        url.API_BASE_URL + url.API_SINGLE_FILE_UPLOAD + `?token=${token}`;

      const response = await uploadSingleFile(requestUrl, file[0]);

      console.log("upload response-------->", response);

      if (response.status) {
        setIsImageUploading(false);
        setCoverImageUrl(url.SERVER_URL + response.data.path);
        setCoverImageId(response.data._id);
        resetCoverImageFile();
      }
    } catch (error) {
      console.error(error.message);
    }
  };

  //function for clear cover image
  const removeCoverImageHandler = () => {
    setCoverImageUrl("");
    setCoverImageId(null);
  };

  // function for clear file value
  const resetCoverImageFile = () => {
    const file = document.getElementById("uploadcoverimage");
    if (file) {
      file.value = null;
    } else {
      return;
    }
  };

  //function for select category
  const categorySelectionHandler = (selectedValues) => {
    setCategoryValue(selectedValues);
    const selectedCategories = selectedValues.map((item) => item.value);
    setSelectedCategories(selectedCategories);
  };

  //function for select company
  const companySelectionHandler = (val) => {
    if (val) {
      setcompanyValue(val);
      setselectedCompanyId(val.value);
    } else {
      setcompanyValue(null);
      setselectedCompanyId(null);
      setCompanyInput("");
      setCompanyList([]);
    }
  };

  //function for open image imput
  const openUploadFileInput = () => {
    uploadFileInputRef.current.click();
  };

  //function for blog file upload
  const blogFileUploadHandler = async (blogUploadedFiles) => {
    try {
      setErrorMessage("");
      setErrors((prev) => ({ ...prev, upload: "" }));
      setIsFileUploading(true);

      let requestUrl =
        url.API_BASE_URL + url.API_MULTIPLE_FILE_UPLOAD + `?token=${token}`;

      const response = await uploadMultipleFile(requestUrl, blogUploadedFiles);

      if (response.status) {
        /*----- assign uploaded files with path for display start ------*/
        const uploadedFileValues = response.data.map(
          ({ name, path, _id, ...other }) => ({
            name,
            path: url.SERVER_URL + path,
            _id,
          })
        );

        //check old file exist or not if exist then new file will concat with old file
        if (uploadedFiles.length == 0) {
          setUploadedFiles(uploadedFileValues);
        } else {
          let fileArr = uploadedFiles.concat(uploadedFileValues);
          setUploadedFiles(fileArr);
        }
        /*----- assign uploaded files with path for display end ------*/

        setIsFileUploading(false);

        /*----- assign uploaded file ids start ------*/
        const fileIds = response.data.map(({ _id, ...other }) => ({ _id }));

        //check old file ids are exist or not.If exist then new id will concat with old id
        if (uploadedFileIds.length == 0) {
          setUploadedFileIds(fileIds);
        } else {
          let fileArr = uploadedFileIds.concat(fileIds);
          setUploadedFileIds(fileArr);
        }
        /*----- assign uploaded file ids end ------*/
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  //function for delete file from upload stack
  const closeBlogFileHandler = (index) => {
    const closedFile = [...uploadedFiles];
    const removedFileId = [...uploadedFileIds];

    closedFile.splice(index, 1);
    removedFileId.splice(index, 1);

    setUploadedFiles(closedFile);
    setUploadedFileIds(removedFileId);
  };

  //function for select publish
  const publishSelectionHandler = (val) => {
    setPublishValue(val);
    setPublishStatus(val.value);
  };

  //function for reset
  const resetBlogHandler = () => {
    setBlogName("");
    setCoverImageUrl("");
    setCoverImageId(null);
    setBlogSummary("");
    setBlogDetails("");
    setCategoryValue(null);
    setCategoryList([]);
    setcompanyValue(null);
    setselectedCompanyId(null);
    setFacebookUrl("");
    setPinterestUrl("");
    setContactEmail("");
    setLinkUrl("");
    setUploadedFiles([]);
    setUploadedFileIds([]);
    setPublishValue(null);
    setPublishStatus(null);
    setErrors({});
  };

  //function for get blog details
  const getBlogDetails = async () => {
    try {
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_BLOG_DETAILS +
        `/${params.id}` +
        `?token=${token}`;

      const response = await getData(requestUrl);

      console.log("response if blog details---->", response);

      if (response.status) {
        setBlogName(response.data?.name);
        setCoverImageUrl(url.SERVER_URL + response.data?.coverimageurl);
        setCoverImageId(response.data?.coverimageid);
        setBlogSummary(response.data?.summary);
        setBlogDetails(response.data?.description);
        setFacebookUrl(response.data?.facebook);
        setContactEmail(response.data?.contactmail);
        setPinterestUrl(response.data?.pinterest);
        setLinkUrl(response.data?.linked);

        setUploadedFiles(
          response.data?.uploads.map(({ name, path, _id, ...other }) => ({
            name,
            path: url.SERVER_URL + path,
            _id,
          }))
        );
        const fileIds = response.data?.uploads.map(({ _id, ...other }) => ({
          _id,
        }));
        setUploadedFileIds(fileIds);

        //assign category
        categorySelectionHandler(response.data?.category);

        //assign company
        companySelectionHandler(response.data?.companydata);

        //assing publish
        if (response.data?.publish) {
          publishOptions.map((publishData) => {
            if (publishData.value == response.data.publish) {
              publishSelectionHandler(publishData);
            }
          });
        }
      } else {
        setErrorMessage(response.message);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  //function for create/update blog
  const saveBlogHandler = async () => {
    if (!validateForm()) {
      setErrorMessage(t("Please fill up the required fields"));
      window.scrollTo({ top: 0, behavior: "smooth" });
      return;
    }

    try {
      setIsSaving(true);

      let blogData = {
        userid: userInfo._id,
        name: blogName,
        coverimage: coverImageId,
        summary: blogSummary,
        description: blogDetails,
        category: selectedCategories,
        uploads: uploadedFileIds,
        publish: publishStatus,
        facebook: facebookUrl,
        linked: linkUrl,
        pinterest: pinterestUrl,
        contactmail: contactEmail,
        companyid: selectedCompanyId,
      };

      let requestUrl = url.API_BASE_URL;

      let response = {};

      if (params.id) {
        requestUrl =
          requestUrl +
          url.API_UPDATE_BLOG +
          `/${params.id}` +
          `?token=${token}`;

        response = await putData(requestUrl, blogData);
      } else {
        requestUrl = requestUrl + url.API_CREATE_NEW_BLOG + `?token=${token}`;

        response = await postData(requestUrl, blogData);
      }

      console.log("response in save blog---->", response);

      if (response.status) {
        setIsSaving(false);
        const bootstrapModal = new bootstrap.Modal(
          document.getElementById("afterSaveBlogModal")
        );
        bootstrapModal.show();
      } else {
        setErrorMessage(response.message);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  const afterSavedModalClose = () => {
    resetBlogHandler();
    if (companyIdParam) {
      history.push(`/admin/companies/articles/${companyIdParam}`);
    } else {
      history.push("/admin/blogs/list");
    }
  };

  /* ---- bread crumb text ---- */
  const breadcrumbText = [
    { title: t("Blog"), link: "/admin/blogs/list" },
    { title: t("Blog Details") },
  ];

  useEffect(() => {
    if (params.id) {
      getBlogDetails();
    }
  }, [params.id]);

  useEffect(() => {
    if (companyInput.length > 1) {
      getAllCompanyList();
    }
  }, [companyInput]);

  useEffect(() => {
    if (companyIdParam) {
      getCompanyDetails();
    }
  }, [companyIdParam]);

  useEffect(() => {
    fetchAllCategories();
  }, []);

  if (
    userInfo.role.slug === "ADMIN" ||
    userInfo.role.slug === "SUPER_ADMIN" ||
    moduleAccess.includes("MOD_CMS")
  ) {
    return (
      <div id="content_wrapper">
        <section className="blog-wrapper bg-white pb-5">
          <div className="container-fluid px-lg-5">
            <BreadCrumb breadCrumbText={breadcrumbText} bottom={true} />

            <div className="create-lead-container p-3 p-md-4 border border-gray-300 rounded-10 shadow-sm">
              {/* ------ title section start ------- */}
              <div className="form-group mb-3 mb-sm-4">
                <label
                  htmlFor="title"
                  className="d-block fs-sm fw-semibold mb-2"
                >
                  {t("Title")}
                </label>
                <input
                  type="text"
                  id="title"
                  className={`form-control fs-sm shadow-none  ${
                    errors.blogName ? "is-invalid" : "border border-gray-300"
                  }`}
                  placeholder="e.g., The Ultimate Guide to Modern Web Development"
                  value={blogName}
                  onChange={(e) => {
                    setBlogName(e.target.value);
                    if (errors.blogName) {
                      setErrors((prev) => ({ ...prev, blogName: "" }));
                    }
                    setErrorMessage("");
                  }}
                />
                {errors.blogName && (
                  <div className="invalid-feedback d-block">
                    Please enter a title for your blog post.
                  </div>
                )}
              </div>
              {/* ------ title section end ------- */}

              {/* ------ cover image section start ------- */}
              <div className="form-group mb-3 mb-sm-4">
                <label
                  htmlFor="logo"
                  className="d-block fs-sm fw-semibold mb-2"
                >
                  {t("Cover Image")}
                </label>
                <FileUploadField
                  label={t("Upload Cover Image")}
                  accept="jpg png jpeg"
                  onUpload={coverImageUploadHandler}
                  files={
                    coverImageUrl
                      ? [{ path: coverImageUrl, name: "Cover Image" }]
                      : [
                          {
                            path: "https://placehold.co/150x150",
                            name: "Cover Image",
                          },
                        ]
                  }
                  onRemove={removeCoverImageHandler}
                  loading={isImageUploading}
                  fileType="image"
                  isError={errors.coverImage}
                />
                {errors.coverImage && (
                  <div className="invalid-feedback d-block">
                    A cover image is required. Please upload one.
                  </div>
                )}
              </div>
              {/* ------ cover image section end ------- */}

              {/* ------ seo summary section start ------- */}
              <div className="form-group mb-3 mb-sm-4">
                <label htmlFor="seo" className="d-block fs-sm fw-semibold mb-2">
                  {t("Summary")}
                </label>
                <textarea
                  name="details"
                  id="details"
                  cols="30"
                  rows="5"
                  className={`form-control fs-sm shadow-none ${
                    errors.blogSummary ? "is-invalid" : "border border-gray-300"
                  }`}
                  placeholder="Write a short, compelling summary for your blog post. This is important for search engine results."
                  value={blogSummary}
                  onChange={(e) => {
                    setBlogSummary(e.target.value);
                    if (errors.blogSummary) {
                      setErrors((prev) => ({ ...prev, blogSummary: "" }));
                    }
                    setErrorMessage("");
                  }}
                ></textarea>
                {errors.blogSummary && (
                  <div className="invalid-feedback d-block">
                    A brief summary is required for your blog post.
                  </div>
                )}
              </div>
              {/* ------ seo summary section end ------- */}

              {/* ------ blog details section start ------ */}
              <div className="form-group mb-3 mb-sm-4">
                <label
                  htmlFor="details"
                  className="d-block fs-sm fw-semibold mb-2"
                >
                  {t("Details")}
                </label>
                <JoditEditor
                  ref={editor}
                  value={blogDetails}
                  config={editorConfig}
                  onBlur={(newContent) => {
                    setBlogDetails(newContent);
                    if (errors.blogDetails) {
                      setErrors((prev) => ({ ...prev, blogDetails: "" }));
                    }
                  }}
                  onChange={(newContent, event) => {
                    // setdetails(newContent);
                  }}
                />
                {errors.blogDetails && (
                  <div className="invalid-feedback d-block">
                    The main content of the blog cannot be empty.
                  </div>
                )}
              </div>
              {/* ------ blog details section end ------ */}

              {/* ------ categories select section start ------ */}
              <div className="form-group mb-3 mb-sm-4">
                <div className="row">
                  <div className="col-lg-6 mb-3 mb-sm-4 mb-lg-0">
                    <label
                      htmlFor="categories"
                      className="d-block fs-sm fw-semibold mb-2"
                    >
                      {t("Categories")}
                    </label>
                    <Select
                      isMulti
                      options={categoryList}
                      value={categoryValue}
                      onChange={(val) => {
                        categorySelectionHandler(val);
                        if (errors.category) {
                          setErrors((prev) => ({ ...prev, category: "" }));
                        }
                        setErrorMessage("");
                      }}
                      styles={getCustomStyles(!!errors.category)} // ✅ only Categories will show red border
                      placeholder="Choose one or more relevant categories..."
                    />
                    {errors.category && (
                      <div className="invalid-feedback d-block">
                        Please select at least one category for your post.
                      </div>
                    )}
                  </div>
                  <div className="col-lg-6 mb-3 mb-sm-4 mb-lg-0">
                    <label
                      htmlFor="company"
                      className="d-block fs-sm fw-semibold mb-2"
                    >
                      {t("Company")}
                    </label>
                    <Select
                      isClearable
                      options={companyList}
                      value={companyValue}
                      onChange={companySelectionHandler}
                      onInputChange={(val) => {
                        setCompanyInput(val);
                        if (errors.company) {
                          setErrors((prev) => ({ ...prev, company: "" }));
                        }
                      }}
                      styles={getCustomStyles(false)}
                      placeholder="Choose one relevant companies..."
                    />
                  </div>
                </div>
              </div>
              {/* ------ categories select section end ------ */}

              {/* ------ facebook and pinterest section start ------- */}
              <div className="form-group mb-3 mb-sm-4">
                <div className="row">
                  {/* ------ facebook section start ------- */}
                  <div className="col-lg-6 mb-3 mb-sm-4 mb-lg-0">
                    <label
                      htmlFor="facebook"
                      className="d-block fs-sm fw-semibold mb-2"
                    >
                      Facebook URL
                    </label>
                    <input
                      type="text"
                      id="facebook"
                      className="form-control fs-sm shadow-none border border-gray-300"
                      placeholder="e.g., https://www.facebook.com/your-post"
                      value={facebookUrl}
                      onChange={(e) => setFacebookUrl(e.target.value)}
                    />
                  </div>
                  {/* ------ facebook section end ------- */}

                  {/* ------ pinterest section start ------- */}
                  <div className="col-lg-6">
                    <label
                      htmlFor="pinterest"
                      className="d-block fs-sm fw-semibold mb-2"
                    >
                      Pinterest URL
                    </label>
                    <input
                      type="text"
                      id="pinterest"
                      className="form-control fs-sm shadow-none border border-gray-300"
                      placeholder="e.g., https://www.pinterest.com/pin/123456789/"
                      value={pinterestUrl}
                      onChange={(e) => setPinterestUrl(e.target.value)}
                    />
                  </div>
                  {/* ------ pinterest section end ------- */}
                </div>
              </div>
              {/* ------ facebook and pinterest section end ------- */}

              {/* ------ contact mail and linked url section start ------- */}
              <div className="form-group mb-3 mb-sm-4">
                <div className="row">
                  {/* ------ contact mail section start ------- */}
                  <div className="col-lg-6 mb-3 mb-sm-4 mb-lg-0">
                    <label
                      htmlFor="contactmail"
                      className="d-block fs-sm fw-semibold mb-2"
                    >
                      {t("Contact Email")}
                    </label>
                    <input
                      type="email"
                      id="contactmail"
                      className="form-control fs-sm shadow-none border border-gray-300"
                      placeholder="e.g., contact@yourdomain.com"
                      value={contactEmail}
                      onChange={(e) => setContactEmail(e.target.value)}
                    />
                  </div>
                  {/* ------ contact mail section end ------- */}

                  {/* ------ linked url section start ------- */}
                  <div className="col-lg-6">
                    <label
                      htmlFor="linkedurl"
                      className="d-block fs-sm fw-semibold mb-2"
                    >
                      {t("Linked URL")}
                    </label>
                    <input
                      type="text"
                      id="linkedurl"
                      className="form-control fs-sm shadow-none border border-gray-300"
                      placeholder="e.g., https://www.example.com/source-article"
                      value={linkUrl}
                      onChange={(e) => setLinkUrl(e.target.value)}
                    />
                  </div>
                  {/* ------ linked url section end ------- */}
                </div>
              </div>
              {/* ------ contact mail and linked url section end ------- */}

              {/* ------ attachment section start ------- */}
              <div className="form-group mb-3 mb-sm-4">
                <label
                  htmlFor="attachments"
                  className="d-block fs-sm fw-semibold mb-2"
                >
                  {t("Attachments")}
                </label>
                <FileUploadField
                  label={t("Attachments")}
                  accept="doc mp4 pdf"
                  onUpload={blogFileUploadHandler}
                  files={uploadedFiles}
                  onRemove={closeBlogFileHandler}
                  loading={isFileUploading}
                  multiple
                  fileType="document"
                />
              </div>
              {/* ------ attachment section end ------- */}

              {/* ------ publish selection section start ------ */}
              <div className="form-group mb-3 mb-sm-4">
                <label
                  htmlFor="categories"
                  className="d-block fs-sm fw-semibold mb-2"
                >
                  {t("Publish")}
                </label>
                <Select
                  options={publishOptions}
                  value={publishValue}
                  onChange={(val) => publishSelectionHandler(val)}
                  placeholder="Choose to publish immediately or save as a draft"
                  styles={getCustomStyles(false)}
                />
              </div>
              {/* ------ publish selection section end ------ */}

              {/* ------ save and cancel button section start ------ */}
              <div className="action d-flex flex-wrap justify-content-between gap-3">
                <Link
                  onClick={resetBlogHandler}
                  to="/admin/blogs/list"
                  className="btn btn-outline-primary"
                >
                  {t("Cancel")}
                </Link>

                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={saveBlogHandler}
                  style={{ cursor: isSaving ? "not-allowed" : "pointer" }}
                  disabled={isSaving ? true : false}
                >
                  {t("Save Now")}
                  {isSaving && (
                    <div
                      className="mx-2 spinner-border spinner-border-sm"
                      role="status"
                    >
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  )}
                </button>
              </div>
              {/* ------ save and cancel button section end ------ */}
            </div>
          </div>
        </section>

        {/* ------ success message modal ------ */}
        <BlogSuccessMessageModal afterSavedModalClose={afterSavedModalClose} />
      </div>
    );
  } else {
    return <AccessDeniedView />;
  }
};

export default AddUpdateBlogBody;
